// Mock data for Northwind Markets clone

export const heroSlides = [
  {
    id: 1,
    title: "Don't chase the market. Copy the people who beat it. From $10, with one tap.",
    cta: "Start copying",
    image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHw0fHwzRCUyMGNoYXJ0fGVufDB8fHx8MTc3ODg0ODIyNXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: 2,
    title: "Precision performance just got a new partner.",
    cta: "Explore",
    image: "https://images.unsplash.com/photo-1631995037903-c4f8064c48ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxzYWlsaW5nJTIwcmFjZXxlbnwwfHx8fDE3Nzg4NDgyMTh8MA&ixlib=rb-4.1.0&q=85",
    badge: "OFFICIAL PARTNER",
  },
  {
    id: 3,
    title: "Built for speed. Tuned for control. Trade your edge on every platform.",
    cta: "Our platforms",
    image: "https://images.unsplash.com/photo-1620266757065-5814239881fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxsYXB0b3AlMjB0cmFkaW5nfGVufDB8fHx8MTc3ODg0ODIxOHww&ixlib=rb-4.1.0&q=85",
  },
];

export const featureCards = [
  {
    id: 1,
    title: "Your gateway to global markets",
    desc: "Trade 2000+ instruments across forex, commodities, indices, and crypto, all in one platform.",
    icon: "globe",
  },
  {
    id: 2,
    title: "Tight spreads, greater profits",
    desc: "Enjoy spreads starting at 0.0 pips, low fees, and transparent pricing for optimal cost efficiency.",
    icon: "chart",
  },
  {
    id: 3,
    title: "Trade at the speed of opportunity",
    desc: "As a highly-rated broker, our platforms are trusted by beginners and pros alike.",
    icon: "lightning",
  },
  {
    id: 4,
    title: "Support that never sleeps",
    desc: "24/7 expert customer service ensures help is always available when you need it.",
    icon: "bubble",
  },
];

export const spreadsData = {
  Popular: [
    { name: "EURUSD", bid: "1.16", ask: "1.16", spread: "0", flag: "\uD83C\uDDEA\uD83C\uDDFA" },
    { name: "Gold", bid: "4554.41", ask: "4554.68", spread: "27", flag: "" },
    { name: "Bitcoin", bid: "80570.00", ask: "80595.00", spread: "2500", flag: "" },
    { name: "DJ30", bid: "49685.87", ask: "49689.13", spread: "326", flag: "\uD83C\uDDFA\uD83C\uDDF8" },
    { name: "Tesla", bid: "279.87", ask: "280.00", spread: "13", flag: "" },
  ],
  Forex: [
    { name: "AUDUSD", bid: "0.72", ask: "0.72", spread: "0", flag: "\uD83C\uDDE6\uD83C\uDDFA" },
    { name: "EURUSD", bid: "1.16", ask: "1.16", spread: "0", flag: "\uD83C\uDDEA\uD83C\uDDFA" },
    { name: "GBPUSD", bid: "1.34", ask: "1.34", spread: "0.0", flag: "\uD83C\uDDEC\uD83C\uDDE7" },
    { name: "USDCAD", bid: "1.38", ask: "1.38", spread: "1", flag: "\uD83C\uDDE8\uD83C\uDDE6" },
    { name: "USDJPY", bid: "158.54", ask: "158.54", spread: "0", flag: "\uD83C\uDDEF\uD83C\uDDF5" },
  ],
  Commodities: [
    { name: "Gold", bid: "4554.41", ask: "4554.68", spread: "27", flag: "" },
    { name: "Silver", bid: "78.28", ask: "78.34", spread: "6", flag: "" },
    { name: "US Crude Oil", bid: "104.16", ask: "104.22", spread: "6", flag: "" },
    { name: "Brent Crude Oil", bid: "110.59", ask: "110.64", spread: "5", flag: "" },
    { name: "Copper", bid: "13520.95", ask: "13529.45", spread: "850", flag: "" },
  ],
  "Share CFDs": [
    { name: "Amazon", bid: "130.26", ask: "130.28", spread: "2", flag: "" },
    { name: "Apple", bid: "192.46", ask: "192.47", spread: "1", flag: "" },
    { name: "Netflix", bid: "441.29", ask: "441.58", spread: "29", flag: "" },
    { name: "NVIDIA", bid: "235.73", ask: "235.86", spread: "13", flag: "" },
    { name: "Tesla", bid: "279.87", ask: "280.00", spread: "13", flag: "" },
  ],
  Indices: [
    { name: "DJ30", bid: "49685.87", ask: "49689.13", spread: "326", flag: "\uD83C\uDDFA\uD83C\uDDF8" },
    { name: "UK100", bid: "10191.16", ask: "10193.16", spread: "200", flag: "\uD83C\uDDEC\uD83C\uDDE7" },
    { name: "GER30", bid: "19368.80", ask: "19376.90", spread: "0.0", flag: "\uD83C\uDDE9\uD83C\uDDEA" },
    { name: "NAS100", bid: "29146.59", ask: "29148.77", spread: "218", flag: "\uD83C\uDDFA\uD83C\uDDF8" },
    { name: "US2000", bid: "2824.58", ask: "2825.28", spread: "70", flag: "\uD83C\uDDFA\uD83C\uDDF8" },
  ],
  "Crypto CFDs": [
    { name: "Bitcoin", bid: "80570.00", ask: "80595.00", spread: "2500", flag: "" },
    { name: "Ethereum", bid: "2256.70", ask: "2260.35", spread: "365", flag: "" },
    { name: "Ripple", bid: "1.46", ask: "1.47", spread: "23", flag: "" },
    { name: "Litecoin", bid: "57.88", ask: "58.28", spread: "40", flag: "" },
    { name: "Solana", bid: "90.77", ask: "91.24", spread: "47", flag: "" },
  ],
};

export const testimonials = [
  {
    id: 1,
    text: "Very helpful when experiencing problem and also the education from John how he analysis the market for free very informative. Support staff very friendly and know what they are doing.",
    author: "Lesley Mtombeni",
    rating: 5,
  },
  {
    id: 2,
    text: "Solid Support Team throughout the whole application process! Love these guys. They also offer a partner referral program where you and your friend can both receive a bonus.",
    author: "James Hwang",
    rating: 5,
  },
  {
    id: 3,
    text: "Another great piece of customer service from John Derek. Patient, polite, prompt, and helped with my login issue.",
    author: "Andrew Blaikie",
    rating: 5,
  },
  {
    id: 4,
    text: "Obaid from the Northwind markets FX website did a great job in helping me through a situation. Very helpful and super quick.",
    author: "Peter Titchener",
    rating: 5,
  },
  {
    id: 5,
    text: "Thank you Allen Dave and Neriza for assisting me in the withdrawal process. Keep up the excellent customer care Northwind Markets.",
    author: "Mark Vincent Cenita",
    rating: 5,
  },
];

export const steps = [
  {
    id: 1,
    title: "Sign up",
    desc: "Create your account in minutes.",
    icon: "user-plus",
  },
  {
    id: 2,
    title: "Fund your account",
    desc: "Secure, easy deposit options.",
    icon: "wallet",
  },
  {
    id: 3,
    title: "Start trading",
    desc: "Access global markets instantly.",
    icon: "trending-up",
  },
];

export const navLinks = [
  {
    label: "Trade",
    items: [
      { title: "Forex", desc: "Trade 60+ currency pairs" },
      { title: "Commodities", desc: "Gold, silver, oil and more" },
      { title: "Indices", desc: "Global stock indices" },
      { title: "Share CFDs", desc: "Apple, Tesla, Amazon and more" },
      { title: "Cryptocurrencies", desc: "Bitcoin, Ethereum, and others" },
    ],
  },
  {
    label: "Platforms",
    items: [
      { title: "MetaTrader 4", desc: "World's most popular platform" },
      { title: "MetaTrader 5", desc: "Next-gen trading platform" },
      { title: "TradingView", desc: "Advanced charting tools" },
      { title: "Northwind X", desc: "Our proprietary platform" },
    ],
  },
  {
    label: "Markets",
    items: [
      { title: "Market News", desc: "Latest market updates" },
      { title: "Economic Calendar", desc: "Upcoming events" },
      { title: "Market Analysis", desc: "Expert insights" },
    ],
  },
  {
    label: "Company",
    items: [
      { title: "About us", desc: "Who we are" },
      { title: "Why Northwind", desc: "Our advantages" },
      { title: "Awards", desc: "Recognized excellence" },
      { title: "Contact", desc: "Get in touch" },
    ],
  },
  {
    label: "Knowledge Hub",
    items: [
      { title: "Education", desc: "Learn to trade" },
      { title: "Trading Glossary", desc: "Key terms explained" },
      { title: "Webinars", desc: "Live training sessions" },
      { title: "Blog", desc: "Latest articles" },
    ],
  },
];

export const footerLinks = {
  "Trade": ["Forex", "Commodities", "Indices", "Share CFDs", "Cryptocurrencies"],
  "Platforms": ["MetaTrader 4", "MetaTrader 5", "TradingView", "Northwind X", "Mobile App"],
  "Company": ["About us", "Why Northwind", "Awards", "Careers", "Contact"],
  "Knowledge Hub": ["Education", "Trading Glossary", "Webinars", "Blog", "FAQ"],
  "Legal": ["Privacy Policy", "Terms of Service", "Risk Disclosure", "Client Agreement", "AML Policy"],
};
